import { useMemo, useState } from 'react';

import Http, { FormatResponse } from 'lib/http';

const defaultOnError = (error) => {
  throw error;
};

const defaultOnSuccess = FormatResponse.jsonApi({});

function buildMakeRequest(method, setLoading) {
  return async (
    url,
    { data = {}, onSuccess = defaultOnSuccess, onError = defaultOnError } = {},
  ) => {
    try {
      setLoading(true);
      const response = await Http[method].call(null, url, data);
      return onSuccess(response);
    } catch (error) {
      return onError(error);
    } finally {
      setLoading(false);
    }
  };
}

const useHttp = () => {
  const [loading, setLoading] = useState(false);
  /* oxlint-disable react-hooks/exhaustive-deps */
  return {
    loading,
    delete: useMemo(() => buildMakeRequest('delete', setLoading), []),
    get: useMemo(() => buildMakeRequest('get', setLoading), []),
    patch: useMemo(() => buildMakeRequest('patch', setLoading), []),
    post: useMemo(() => buildMakeRequest('post', setLoading), []),
    put: useMemo(() => buildMakeRequest('put', setLoading), []),
  };
  /* oxlint-enable react-hooks/exhaustive-deps */
};

export default useHttp;
